// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar2 {
  background-color: #939393;
  padding: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  font-weight: 800;
  font-size: 1.5rem;
  transition: color 0.3s;
  margin-bottom: 1rem;

  &:hover {
    color: #76bbe9;
  }
}

.companylogo {
  border-radius: 5rem;
  position: absolute;
  top: 15vw;
  left: 5vw;
}

.cart-icon {
  height: 1.5rem;
  width: 1.5rem;
}

.navbar-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
}

.navbar-item {
  margin: 0 15px 0 0;
  position: relative;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.navbar-link {
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  font-weight: 800;
  font-size: 1.75rem;
  flex-wrap: wrap;
  transition: color 0.3s;
  margin-bottom: 1rem;

  &:hover {
    color: #76bbe9;
  }
}

.dropdown {
  display: none;
  position: relative;
  background-color: #939393;
  list-style-type: none;
  padding: 0;
  margin: 0;
  top: 100%;
  left: 0;
  z-index: 103;
}

.navbar-item:hover .dropdown {
  display: block;
}

.dropdown .navbar-link {
  padding: 10px 0px 10px 0;
  display: block;
  white-space: nowrap;
}

.dropdown .navbar-link:hover {
  background-color: #969696;
  color: #76bbe9;
}

.desktop-navbar {
  display: flex;
}

/* Burger Menu Styles */
.menu-toggle {
  display: none;
}

.burger {
  position: relative;
  width: 60px;
  height: 60px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.bar {
  display: block;
  width: 100%;
  height: 10px;
  background-color: #247a97;
  border-radius: 4px;
  transition: all 0.5s ease-in-out;
}

/* Transformations when menu is toggled */
.menu-toggle:checked + .burger .bar:nth-child(1) {
  transform: rotate(45deg);
  position: absolute;
}

.menu-toggle:checked + .burger .bar:nth-child(2) {
  opacity: 0;
  width: 0%;
}

.menu-toggle:checked + .burger .bar:nth-child(3) {
  transform: rotate(-45deg);
  position: absolute;
}

.mobile-navbar {
  display: none;
  flex-direction: column;
  line-height: 2.5rem;
  background-color: #afafaf;
  border-radius: 10px;
  transition: all 0.3s ease;
  position: relative;
  opacity: 0.95;
  width: 100%;
}

.menu-toggle:checked ~ .mobile-navbar {
  display: flex;
}

.navbar-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-weight: 800;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform 0.3s, border-color 0.3s;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.navbar-btn:hover {
  transform: scale(0.9);
  border-color: white;
}

.quote-btn,
.phone-btn {
  background-color: #247a97;
  fill: #ffffff;
  color: #ffffff;
  position: absolute;
  letter-spacing: 0.5px;
  transition: transform 0.3s;
  font-size: 1.5rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0px 10px 0px;
  padding: 15px 40px 15px 40px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
}

.quote-btn {
  top: 2vh;
  right: 10vw;
}

.phone-btn {
  top: 2vh;
  left: 10vw;
}

.navbar-btn:hover {
  background-color: #247a97;
}

/* Media query for screens with width ≤ 670px */
@media screen and (max-width: 670px) {
  .companylogo {
    position: absolute;
    left: 5rem;
    top: 5rem;
    transform: scale(0.5);
  }

  .contactButtons {
    gap: 0rem;
  }

  .navbar2 .navbar-btn.phone-btn,
  .navbar2 .navbar-btn.quote-btn {
    position: static;
    margin: 15px 0;
    font-size: 2.5rem;
  }
}

/* Media query for screens with width ≤ 890px */
@media screen and (max-width: 890px) {
  /* .contactButtons {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 3vh;
    left: 27vw;
  } */
  .navbar2 .navbar-btn.phone-btn,
  .navbar2 .navbar-btn.quote-btn {
    position: static;
    margin: 15px 0;
    font-size: 2.5rem;
  }
}

/* Media query for screens with width ≤ 991px */
@media screen and (max-width: 991px) {
  .navbar2 {
    width: 100%;
    justify-content: space-between;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 10rem;
    background-color: #939393;
  }

  .companylogo {
    display: none;
  }

  .burger {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 10px;
    z-index: 103;
  }

  .mobile-navbar {
    display: none;
    flex-direction: column;
    line-height: 2.5rem;
    background-color: #afafaf;
    border-radius: 10px;
    transition: all 0.3s ease;
    position: absolute;
    top: 5px;
    z-index: 102;
    width: 100vw;
  }

  .navbar2 .navbar-btn {
    display: block;
    width: -moz-fit-content;
    width: fit-content;
    margin: 5px 0;
  }

  .navbar2 .phone-btn {
    position: absolute;
    left: 10px;
    top: 45vh;
    width: -moz-max-content;
    width: max-content;
    border-color: white;
  }

  .quote-btn {
    width: -moz-fit-content;
    width: fit-content;
  }

  .navbar2 .navbar-btn.phone-btn,
  .navbar2 .navbar-btn.quote-btn {
    font-size: 2.5rem;
    font-weight: 600;
    border-width: 4px 4px 4px 4px;
    border-style: solid;
    border-radius: 10px 0px 10px 0px;
    padding: 5px 20px 5px 20px;
    box-shadow: 5px 5px 5px 0px
      rgba(12, 11.000000000000002, 11.000000000000002, 0.77);

    &:hover {
      background-color: #76bbe9;
    }
  }

  .navbar-link {
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #ffffff;
    font-weight: 800;
    font-size: 4.5rem;
    flex-wrap: wrap;
    transition: color 0.3s;
    margin: 2.5rem 0;

    &:hover {
      color: #76bbe9;
    }
  }

  .dropdown .navbar-link {
    padding: 2rem 0px 2rem 0;
    display: block;
    white-space: nowrap;
  }

  .dropdown .navbar-link:hover {
    background-color: #969696;
    color: #76bbe9;
  }

  .navbar2 .contactButtons {
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    left: 10px;
    top: 10px;
  }

  .desktop-navbar {
    display: none;
  }

  .menu-toggle {
    display: none;
  }
}

@media screen and (min-width: 992px) {
  .companylogo {
    display: none;
  }

  .burger {
    display: none;
  }

  .navbar-btn {
    display: none;
  }

  .menu-toggle {
    display: none;
  }

  .navbar-link {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Navbar2.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B;0DACwD;AAC1D;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE;;;;;;;KAOG;EACH;;IAEE,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uBAAkB;IAAlB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;IAC1B;4DACwD;;IAExD;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;;IAEhB;MACE,cAAc;IAChB;EACF;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".navbar2 {\n  background-color: #939393;\n  padding: 10px 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 1.5rem;\n  transition: color 0.3s;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: #76bbe9;\n  }\n}\n\n.companylogo {\n  border-radius: 5rem;\n  position: absolute;\n  top: 15vw;\n  left: 5vw;\n}\n\n.cart-icon {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.navbar-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n}\n\n.navbar-item {\n  margin: 0 15px 0 0;\n  position: relative;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.navbar-link {\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 1.75rem;\n  flex-wrap: wrap;\n  transition: color 0.3s;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: #76bbe9;\n  }\n}\n\n.dropdown {\n  display: none;\n  position: relative;\n  background-color: #939393;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  top: 100%;\n  left: 0;\n  z-index: 103;\n}\n\n.navbar-item:hover .dropdown {\n  display: block;\n}\n\n.dropdown .navbar-link {\n  padding: 10px 0px 10px 0;\n  display: block;\n  white-space: nowrap;\n}\n\n.dropdown .navbar-link:hover {\n  background-color: #969696;\n  color: #76bbe9;\n}\n\n.desktop-navbar {\n  display: flex;\n}\n\n/* Burger Menu Styles */\n.menu-toggle {\n  display: none;\n}\n\n.burger {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.bar {\n  display: block;\n  width: 100%;\n  height: 10px;\n  background-color: #247a97;\n  border-radius: 4px;\n  transition: all 0.5s ease-in-out;\n}\n\n/* Transformations when menu is toggled */\n.menu-toggle:checked + .burger .bar:nth-child(1) {\n  transform: rotate(45deg);\n  position: absolute;\n}\n\n.menu-toggle:checked + .burger .bar:nth-child(2) {\n  opacity: 0;\n  width: 0%;\n}\n\n.menu-toggle:checked + .burger .bar:nth-child(3) {\n  transform: rotate(-45deg);\n  position: absolute;\n}\n\n.mobile-navbar {\n  display: none;\n  flex-direction: column;\n  line-height: 2.5rem;\n  background-color: #afafaf;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  position: relative;\n  opacity: 0.95;\n  width: 100%;\n}\n\n.menu-toggle:checked ~ .mobile-navbar {\n  display: flex;\n}\n\n.navbar-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  font-weight: 800;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: transform 0.3s, border-color 0.3s;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.navbar-btn:hover {\n  transform: scale(0.9);\n  border-color: white;\n}\n\n.quote-btn,\n.phone-btn {\n  background-color: #247a97;\n  fill: #ffffff;\n  color: #ffffff;\n  position: absolute;\n  letter-spacing: 0.5px;\n  transition: transform 0.3s;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0px 10px 0px;\n  padding: 15px 40px 15px 40px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n}\n\n.quote-btn {\n  top: 2vh;\n  right: 10vw;\n}\n\n.phone-btn {\n  top: 2vh;\n  left: 10vw;\n}\n\n.navbar-btn:hover {\n  background-color: #247a97;\n}\n\n/* Media query for screens with width ≤ 670px */\n@media screen and (max-width: 670px) {\n  .companylogo {\n    position: absolute;\n    left: 5rem;\n    top: 5rem;\n    transform: scale(0.5);\n  }\n\n  .contactButtons {\n    gap: 0rem;\n  }\n\n  .navbar2 .navbar-btn.phone-btn,\n  .navbar2 .navbar-btn.quote-btn {\n    position: static;\n    margin: 15px 0;\n    font-size: 2.5rem;\n  }\n}\n\n/* Media query for screens with width ≤ 890px */\n@media screen and (max-width: 890px) {\n  /* .contactButtons {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    top: 3vh;\n    left: 27vw;\n  } */\n  .navbar2 .navbar-btn.phone-btn,\n  .navbar2 .navbar-btn.quote-btn {\n    position: static;\n    margin: 15px 0;\n    font-size: 2.5rem;\n  }\n}\n\n/* Media query for screens with width ≤ 991px */\n@media screen and (max-width: 991px) {\n  .navbar2 {\n    width: 100%;\n    justify-content: space-between;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin-bottom: 10rem;\n    background-color: #939393;\n  }\n\n  .companylogo {\n    display: none;\n  }\n\n  .burger {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    padding: 10px;\n    z-index: 103;\n  }\n\n  .mobile-navbar {\n    display: none;\n    flex-direction: column;\n    line-height: 2.5rem;\n    background-color: #afafaf;\n    border-radius: 10px;\n    transition: all 0.3s ease;\n    position: absolute;\n    top: 5px;\n    z-index: 102;\n    width: 100vw;\n  }\n\n  .navbar2 .navbar-btn {\n    display: block;\n    width: fit-content;\n    margin: 5px 0;\n  }\n\n  .navbar2 .phone-btn {\n    position: absolute;\n    left: 10px;\n    top: 45vh;\n    width: max-content;\n    border-color: white;\n  }\n\n  .quote-btn {\n    width: fit-content;\n  }\n\n  .navbar2 .navbar-btn.phone-btn,\n  .navbar2 .navbar-btn.quote-btn {\n    font-size: 2.5rem;\n    font-weight: 600;\n    border-width: 4px 4px 4px 4px;\n    border-style: solid;\n    border-radius: 10px 0px 10px 0px;\n    padding: 5px 20px 5px 20px;\n    box-shadow: 5px 5px 5px 0px\n      rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n\n    &:hover {\n      background-color: #76bbe9;\n    }\n  }\n\n  .navbar-link {\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n    color: #ffffff;\n    font-weight: 800;\n    font-size: 4.5rem;\n    flex-wrap: wrap;\n    transition: color 0.3s;\n    margin: 2.5rem 0;\n\n    &:hover {\n      color: #76bbe9;\n    }\n  }\n\n  .dropdown .navbar-link {\n    padding: 2rem 0px 2rem 0;\n    display: block;\n    white-space: nowrap;\n  }\n\n  .dropdown .navbar-link:hover {\n    background-color: #969696;\n    color: #76bbe9;\n  }\n\n  .navbar2 .contactButtons {\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    position: absolute;\n    left: 10px;\n    top: 10px;\n  }\n\n  .desktop-navbar {\n    display: none;\n  }\n\n  .menu-toggle {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .companylogo {\n    display: none;\n  }\n\n  .burger {\n    display: none;\n  }\n\n  .navbar-btn {\n    display: none;\n  }\n\n  .menu-toggle {\n    display: none;\n  }\n\n  .navbar-link {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
